var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-autocomplete',{attrs:{"fetch-suggestions":_vm.querySearch,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"clearable":_vm.clearable,"value-key":"productName"},on:{"select":_vm.handleSelect},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }